function Chile({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_521_922)">
      <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
      <path d="M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 7.16353 16 16 16 16C16 16 28.1101 16 32 16Z" fill="#D80027"/>
      <path d="M0 16C0 7.1635 7.1635 0 16 0V16C16 16 5.56519 16 0 16Z" fill="#0052B4"/>
      <path d="M9.52437 5.56519L10.5604 8.75381H13.9131L11.2007 10.7244L12.2367 13.9131L9.52437 11.9424L6.81199 13.9131L7.84799 10.7244L5.13562 8.75381H8.4883L9.52437 5.56519Z" fill="#F0F0F0"/>
    </g>
  </svg>

  `;

  return baseXml;
}

export default Chile;
